import { render, staticRenderFns } from "./SupplierRawMaterialContaminantsPesticides.vue?vue&type=template&id=557d6ef7&scoped=true&"
import script from "./SupplierRawMaterialContaminantsPesticides.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialContaminantsPesticides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557d6ef7",
  null
  
)

export default component.exports